module.exports = __webpack_public_path__ + "static/media/romanticos_masculino_roupas.8f516655.jpg";